import { render, staticRenderFns } from "./ProviderFees.vue?vue&type=template&id=d0912618&lang=pug&"
import script from "./ProviderFees.vue?vue&type=script&lang=js&"
export * from "./ProviderFees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports